import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { EntityPagesTitle, PagesTitle } from 'src/app/app-pages-title/app-pages-title';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import ProjectLinks from 'src/app/common/project.links';
import { RouteService } from 'src/app/services/route-service.abstract';
import { Post } from 'src/app/swagger-api';
import { PostDetailService } from './post-detail-info/post-detail.service';

@Injectable({ providedIn: 'root' })
export class PostRoutesService extends RouteService<Post, EntityPagesTitle> {
  private postService = inject(PostDetailService);

  public constructor() {
    super();

    this.subscribeToData(
      this.postService.postChanges.pipe(
        catchError(() => {
          promiseWithCatch(this.router.navigate([ProjectLinks.LINK_POSTS_ALL]));
          return EMPTY;
        }),
      ),
    );
  }

  public loadData(id: string): void {
    this.postService.getPostDetailInfo(id);
  }

  public buildTitle({ title }: Post): EntityPagesTitle {
    return {
      viewPage: this.translate(PagesTitle.POST_VIEW_PAGE, { postTitle: title }),
      editPage: this.translate(PagesTitle.POST_EDIT_PAGE, { postTitle: title }),
    };
  }

  public verifyAccess(post: Post): void {
    if (post.creator.user_id !== this.sessionService.userId) {
      promiseWithCatch(this.router.navigate([ProjectLinks.LINK_POSTS_VIEW, post.entity_id]));

      this.informService.showFailureMessage({
        title: '',
        level: 'ERROR',
        content: [{ type: 'text', value: 'MANAGE_POST_NO_ACCESS_DESCRIPTION' }],
        replies: [],
      });
    }
  }
}
